import { Select } from '@postenbring/hedwig-react'


export const LinksDropdown = ({ label, options, placeholder }) => {

    const handleOnChange = (event) => {
        window.location = event.target.value;
    }

    return (
        <Select label={label} defaultValue="" onChange={handleOnChange} className="hds-mb-20-24">
            <option disabled hidden value="">
                {placeholder}
            </option>
            {options.map((option, index) => (
                <option key={index} value={option.link}>
                    {option.linkText}
                </option>
            ))}
        </Select>

    )
}